module.exports = __webpack_public_path__ + "img/task.f1667d6e.svg";